angular.module('impactx.requestItem').controller('EditRequestItemCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'itemId',
    'headerId',
    'entryPointGet',
    'entryPointSave',
    '$mdToast',
    '$context',
    'lotId',
    'productId',
    'readOnly',
    'materialGroupMappingEntryPoint',
    '$securityManager',
    'OutsourcedCommentSaveService',
    'changeAATEntryPoint',
    'hideOrderData',
    'contractId',
    'themeFactory',
    EditRequestItemCtrl
]);

function EditRequestItemCtrl($scope, dataGen, $mdDialog, TranslationService, itemId, headerId, entryPointGet, entryPointSave, $mdToast,
                             $context, lotId, productId, readOnly, materialGroupMappingEntryPoint, $securityManager, OutsourcedCommentSaveService, changeAATEntryPoint,
                             hideOrderData, contractId, themeFactory) {
    $scope.materialGroupMappingEntryPoint = materialGroupMappingEntryPoint;
    $scope.isExternalGuest = {value: $securityManager.isProcessAllowed("OrderGuestBasket") && !$securityManager.isSuperUser()};
    $scope.hideOrderData = hideOrderData;
    $scope.errorList = [];
    $scope.myDate = new Date();
    $scope.minDate = new Date(
        $scope.myDate.getFullYear(),
        $scope.myDate.getMonth(),
        $scope.myDate.getDate());
    $scope.moreDetails = false;
    $scope.theme = themeFactory.getTheme();

    $scope.zeroNotAllowedLabel = TranslationService.get("zeroNotAllowed");
    $scope.noDigitsAllowedLabel = TranslationService.get("noDigitsAllowed");
    $scope.toggleDetails = function () {
        $scope.moreDetails = !$scope.moreDetails;
    };

    $scope.showDetails = function () {
        $scope.moreDetails = true;
    };

    $scope.getItemData = function () {
        var dataObj,
            sourceProductId = productId > 0 ? productId : 0;

        dataObj = {id: itemId, headerId: headerId, productId: sourceProductId};

        if (lotId > -1) {
            dataObj.lotId = lotId;
        }
        if (contractId > -1) {
            dataObj.contractId = contractId;
        }

        dataGen.getData($scope, dataObj, entryPointGet, function () {
            $scope.handleData();
        });
    };

    $scope.getItemData();

    $scope.handleData = function () {
        $scope.eClassDataArray = [{field: "eClass", value: $scope.data.requestItem.eClass},
            {field: "sapConfigId", value: $scope.data.requestItem.sapConfigId}];

        handleControlDataForChips($scope.data.requestItem.control);

        if ($scope.data.requestItem.comments) {
            if ($scope.data.requestItem.comments.internalComments) {
                $scope.data.requestItem.comments.internalComments.newComments = [];
            }
            if ($scope.data.requestItem.comments.externalComments) {
                $scope.data.requestItem.comments.externalComments.newComments = [];
            }
        }

        if ($scope.data.requestItem.contract) {
            if ($scope.data.requestItem.contract.selected && $scope.onContractSelect) {
                $scope.onContractSelect($scope.data.requestItem.contract.selected);
            }
        }

        $scope.scrollList = [];

        $scope.scrollList.push({id: "general", label: $scope.trns.general});
        if(!$scope.isExternalGuest || !$scope.isExternalGuest.value)
        {
            $scope.scrollList.push({id: "moreDetails", label: $scope.trns.details});
        }
        if (!$scope.isExternalGuest.value) {
            if (!$scope.hideOrderData) {
                $scope.scrollList.push({id: "control", label: $scope.trns.control, func: $scope.showDetails});

                if (!$scope.data.requestItem.hideAddresses) {
                    $scope.scrollList.push({id: "address", label: $scope.trns.address, func: $scope.showDetails});
                }

                $scope.scrollList.push({id: "internalcomments", label: $scope.trns.internalComments});
                $scope.scrollList.push({id: "externalcomments", label: $scope.trns.externalComments});
            }

        }
        if ($scope.data.requestItem.foreignOrderData || $scope.data.requestItem.sapData || $scope.data.requestItem.processAttributes) {
            $scope.scrollList.push({id: "process", label: $scope.trns.process});

        }
        if ($scope.data.requestItem.hasAttributes) {
            $scope.scrollList.push({id: "attributes", label: $scope.trns.attributes});
        }
        if ($scope.data.requestItem.deliveryDate) {
            if ($scope.data.requestItem.deliveryDate.minDate) {
                $scope.data.requestItem.deliveryDate.minDate = new Date($scope.data.requestItem.deliveryDate.minDate);
            }
            if ($scope.data.requestItem.deliveryDate.maxDate) {
                $scope.data.requestItem.deliveryDate.maxDate = new Date($scope.data.requestItem.deliveryDate.maxDate);
            }
        }

    };

    $scope.closeFunction = function () {
        $scope.hide();
        $mdToast.show(
            $mdToast.simple()
                .textContent("Speichern erfolgreich")
                .position("bottom right")
                .hideDelay(10000)
        );
    };

    $scope.savePageData = function (data) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(data.requestItem);

        var dataObj = {
            data: data
        };
        dataGen.post({}, dataObj, entryPointSave).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then($scope.closeFunction, $scope.closeFunction);
            }
            else {
                $scope.closeFunction();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments(data.requestItem, extractedComments);
        });
    };

    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.answer = function (answer) {
        $mdDialog.hide(answer);
    };

    $scope.showAccounting = function () {
        if ((!$scope.data.requestItem.isFreeform || impactX.isDefined($scope, 'data.requestItem.contract.selected.id')) && !$scope.hideOrderData) {
            var ctrl = $scope.data.requestItem.control;
            return ctrl.ctu || ctrl.ctt || ctrl.prj || ctrl.ctrlA || ctrl.ctrlB || ctrl.ctrlC || ctrl.ctrlD || ctrl.crd ||
                ctrl.psp || ctrl.asn || ctrl.ino || ctrl.loc || ctrl.eko || ctrl.ekg || ctrl.act || ctrl.net;
        }
        return false;
    };

    $scope.changeAat = function (aatId, itemId) {
        dataGen.postAsForm({}, {aatId: aatId, itemId: itemId}, changeAATEntryPoint).then(function (result) {
            if (result && result.data) {
                $scope.data.requestItem.control = result.data;
            }
        });
    };
}
